import { Container } from 'theme-ui';
import styles from '@features/voxbox/sections/Information/InformationSection.styles';
import { IInformation } from '@features/voxbox/typescript';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import { BASE_PATH } from '@config/index';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  information: IInformation;
};
const InformationSection = ({
  information
}: PropsType) => {
  const {
    items
  } = information;
  return <section sx={styles.section} data-cy="InformationSection">
      <Container>
        <div sx={styles.mainRow}>
          <div />
          <div sx={styles.info}>
            <div sx={styles.infoWrapper}>
              {items.map((item, index) => <div key={item.itemId} data-cy="InformationSectionContent">
                  <Heading display={3} color={theme.rawColors.neutralBlack} pb={20} mobile>
                    {item.header}
                  </Heading>
                  <p sx={styles.subtitle(index === items.length - 1)}>{item.text}</p>
                </div>)}
            </div>
          </div>
          <div />
          <div>
            <div sx={styles.imageWrapper} data-cy="InformationSectionImage">
              <div>
                <ResponsiveImage image={`${BASE_PATH}/img/voxbox/monitor.png`} alt="" objectFit="contain" />
              </div>
            </div>
          </div>
          <div />
        </div>
      </Container>
    </section>;
};
export default InformationSection;